import React, { Component, Suspense, lazy } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Spinner from "../app/shared/Spinner";
import { ProfileContext } from "./context/ProfileContext";
const Dashboard = lazy(() => import("./user-pages/dashboard/Dashboard"));
const Withdrawal = lazy(() => import("./user-pages/withdrawal/Withdrawal"));
const Deposit = lazy(() => import("./user-pages/deposit-transaction/Deposit"));
const Transaction = lazy(() => import("./user-pages/deposit-transaction/Transaction"));
const OnlineStore = lazy(() => import("./user-pages/onlinestore/OnlineStore"));
const NetworkReward = lazy(() => import("./user-pages/networkreward/NetworkReward"));
const MyTeam = lazy(() => import("./user-pages/myteam/MyTeam"));
const RankRecognition = lazy(() => import("./user-pages/rank-recognition/RankRecognition"));
const AccountSetting = lazy(() => import("./user-pages/profile/AccountSetting"));
const Support = lazy(() => import("./user-pages/profile/Support"));
const Document = lazy(() => import("./user-pages/profile/DocumentPages"));
const Wallet = lazy(() => import("./user-pages/wallet/Wallet"));
const PurchaseHistory = lazy(() => import("./user-pages/onlinestore/PurchaseHistory"));
const DownlineUser = lazy(() => import("./user-pages/myteam/myteamtabs/tablestructure/DownlineUser"));
const LevelNetworkReward = lazy(() => import("./user-pages/networkreward/LevelNetworkReward"));
const CommisopnReport = lazy(() => import("./user-pages/commision-report/CommisionReport"));
const LoginDesign = lazy(() => import("./auth/login"));
const RegistrationDesign = lazy(() => import("./auth/registration"));
const ForgotPasswordDesign = lazy(() => import("./auth/forgot_password"));
const BusinessInfo = lazy(() => import("./user-pages/business-info/BusinessInfo"));
const SupportChat = lazy(() => import("./user-pages/profile/SupportChat"));
const ActivityLog = lazy(() => import("./user-pages/activity-log/ActivityLog"));
const AVFXWallet = lazy(() => import("./user-pages/avfx-wallet/AVFXWallet"));
class AppRoutes extends Component {
    static contextType = ProfileContext;

    // CHECK INDEX FILE TO FIX THE basename OF THE SUBDIRECTORY
    render() {
        return (<>
            <Suspense fallback={<Spinner />}>
                <Switch>
                    <Route exact path="/dashboard" component={Dashboard} />
                    <Route exact path="/login" component={LoginDesign} />
                    {/* <Route exact path="/registration" component={RegistrationDesign} /> */}
                    <Route exact path="/forgotpassword" component={ForgotPasswordDesign} />
                    <Route exact path="/deposit&transaction/deposittowallet" component={Deposit} />
                    <Route exact path="/deposit&transaction/fundtransfer" component={Transaction} />
                    <Route exact path="/onlinestore" component={OnlineStore} />
                    <Route exact path="/purchasehistory" component={PurchaseHistory} />
                    <Route exact path="/networkreward" component={NetworkReward} />
                    <Route exact path="/networkreward/levelnetworkreward" component={LevelNetworkReward} />
                    <Route exact path="/myteam" component={MyTeam} />
                    <Route exact path="/myteam/downlineuser" component={DownlineUser} />
                    <Route exact path="/withdrawal" component={Withdrawal} />
                    <Route exact path="/rankrecognition" component={RankRecognition} />
                    <Route exact path="/profile/accountsettings" component={AccountSetting} />
                    <Route exact path="/support" component={Support} />
                    <Route exact path="/support/chat/:tk_id" component={SupportChat} />
                    <Route exact path="/wallet" component={Wallet} />
                    <Route exact path="/commisionreport" component={CommisopnReport} />
                    <Route exact path="/businessinfo" component={BusinessInfo} />
                    <Route exact path="/profile/activitylog" component={ActivityLog} />
                    <Route exact path="/document" component={Document} />
                    {this.context?.profileData?.avfx_enable && (

                        <Route exact path='/avfxwallet' component={AVFXWallet} />
                    )}
                    <Redirect to="/login" />
                </Switch>

            </Suspense>
        </>
        );
    }
}

export default AppRoutes;
